// extracted by mini-css-extract-plugin
module.exports = {"text":"LogoH1_text__clHWk"};